import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import { SearchWidget } from 'pages/HomePage/components'
import { Footer, MainLayout, NavBar, PageContainer } from 'shared'
import { loadChampionship, resetValue } from 'state/modules/championships'

import { EditForm, PlaceholderLoader } from './components'
import { useStyles } from './EditPage.style'

const EditPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isFirstRender = useRef(true)

  const { slugUrlOrId } = useParams()

  const { championship, pending } = useSelector((state) => state.championships)

  const activeLoading = isFirstRender.current || pending
  useEffect(() => {
    dispatch(loadChampionship(slugUrlOrId))

    return () => dispatch(resetValue('championship'))
  }, [dispatch, slugUrlOrId])

  useEffect(() => {
    isFirstRender.current = false
  }, [])

  const renderLoading = () => <PlaceholderLoader />

  const renderPage = () => {
    if (!championship)
      return (
        <div className={classes.noPermissionContainer}>
          <Typography variant='h6' color='primary' className={classes.noPermissionTitle}>
            Ocurrió un error al cargar el formulario del campeonato.
          </Typography>
        </div>
      )

    const { loggedUserMetadata } = championship

    if (!loggedUserMetadata?.canEdit) {
      return (
        <div className={classes.noPermissionContainer}>
          <Typography variant='h6' color='primary' className={classes.noPermissionTitle}>
            No tienes permisos para crear campeonatos con esta organización.
          </Typography>
        </div>
      )
    }

    return renderForm()
  }

  const renderForm = () => {
    const { name } = championship

    return (
      <div className={classes.container}>
        <div className={classes.mainContainer}>
          <div className={classes.headerContainer}>
            <Typography className={classes.title} color='primary' variant='h5' title={name}>
              {name}
            </Typography>
          </div>
          <EditForm />
        </div>
      </div>
    )
  }

  return (
    <MainLayout>
      <MainLayout>
        <NavBar widget={(props) => <SearchWidget mini {...props} />} altMode />
        <PageContainer customContainerClassName={classes.container} altMode>
          {!activeLoading ? renderPage() : renderLoading()}
        </PageContainer>
        <Footer />
      </MainLayout>
    </MainLayout>
  )
}

export default EditPage
